import {React, useState, useEffect} from 'react'
import Header from '../../component/Header'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {orderBy, db,  collection, query, where, getDocs, deleteDoc, doc } from '../../firebase/index';
import PaymentCard from '../../component/PaymentCard';
export default function Payment() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [students, setStudents] = useState([]);
  const [payment, setPayment] = useState([]);
  const fetchStudents = async () => {
    const q = query(collection(db, "students"),orderBy('name'));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const data = {
        id: doc.id,
        ...doc.data()
      }
      setStudents((students) => [...students, data]);
    });
  }
  const deleteRecord = async (id) => {
    try {
      await deleteDoc(doc(db, "payments", id));
      setPayment(currentPayment => 
        currentPayment.filter(record => record.id !== id)
      );
      alert("Document successfully deleted!");
    } catch (error) {
      alert("Error removing document: ", error);
    }
  };

  const fetchPayment = async () => {
    setPayment([])
    const formattedStartDate = startDate.toISOString().slice(0, 10);
    const formattedEndDate = endDate.toISOString().slice(0, 10);
    const q = query(collection(db, "payments") ,orderBy("date"),where("student_id", "==", selectedStudentId), where('date', '<=',  formattedEndDate) , where('date', '>=', formattedStartDate));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const data = {
        id: doc.id,
        ...doc.data()
      }
      setPayment((payment) => [...payment, data]);
    });
  }

  useEffect(()=>{
    fetchStudents();
  }, [])

  return (
    <div>
      <Header/>
      <div className="p-10 bg-gray-100">
          <h1 className="text-blue-800 text-4xl font-bold">
            Payment
          </h1>
      </div>
      <div className='flex flex-wrap justify-around px-20 py-5 bg-gray-100 '>
        <div>
            <div className="mb-2">
              Start Date: 
            </div>
            <div>
              <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
            </div>
        </div>
        <div>
          <div className="mb-2">
            End Date:
          </div>
          <div>
            <DatePicker selected={endDate} onChange={(date) => setEndDate(date)} />
          </div>
        </div>
        <div>
          <div className="max-w-sm mx-auto">
            <label for="countries" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Student: </label>
            <select onChange={(e)=>{setSelectedStudentId(e.target.value)}} id="countries" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <option selected>Student</option>
              {students.map((s, index)=>{
                return(
                  <option key={index} value={s.id}>{s.name}</option>
                )
              })}
            </select>
          </div>

        </div>
      </div>
      <div class="flex justify-center items-center h-12 bg-gray-100 py-10">
        <button onClick={()=>{fetchPayment()}} class="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 rounded-lg text-xl px-5 py-2.5 text-center">
          Fetch
        </button>
      </div>
      <div className='flex flex-wrap justify-around gap-1 py-10 bg-black md:px-10'>
        {
          payment.map((p, index) => {
            return (
              <div key={index} className='lg:w-1/4 xl:w-1/5 p-2'>
                <PaymentCard data={p} 
                deleteRecord={ deleteRecord }/>
              </div>
            );
          })
        }
      </div>

    </div>

  );
}
